import lodash from "lodash";
import { parseExperiments } from "./../../wix-rich-content-common/lib/experiments";
function experimentStrategy(wixExperiments) {
  const features = {
    ricosFeatures: {},
    wixRicosFeatures: {}
  };
  if (!wixExperiments) {
    return features;
  }
  const unboxed = lodash.isFunction(wixExperiments?.all) ? wixExperiments.all() : wixExperiments;
  const experiments = parseExperiments(unboxed);
  return Object.entries(experiments).reduce((featureList, [name, experiment]) => {
    if (experiment?.namespace === "wixRicos") {
      featureList.wixRicosFeatures[name] = experiment;
    } else if (experiment?.namespace === "ricos") {
      featureList.ricosFeatures[name] = experiment;
    }
    return featureList;
  }, features);
}
export {
  experimentStrategy
};
//# sourceMappingURL=experimentStrategy.js.map
